import { DeepNonNullable } from './utilTypes';

export default function filterObjectNulls<T extends {}>(
  obj: T
): DeepNonNullable<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v != null)
  ) as DeepNonNullable<T>;
}
